module.exports = __webpack_public_path__ + "img/payment-verified.adcb51ba.png";